import React, { memo } from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { Icon } from "../Icon/Icon"
import { withModalsDrawer } from "./withModalsDrawer"
import { BackgroundContainer, StyledContainer } from "../Styled/Container"

const BgContainer = styled(BackgroundContainer)<BgContainerProps>`
  ${tw`fixed right-0 top-0 left-0 transition-all duration-slow`}
  ${({ active }) => (active ? tw`opacity-100 visible` : tw`opacity-0 invisible`)}
  ${({ activeCart, activeMenu }) => (!activeCart && activeMenu ? tw`z-1` : tw`z-40`)}
`
// ${tw`z-40 fixed right-0 bottom-0 top-0 left-0 transition-all duration-slow`}

const Container = styled(StyledContainer)<ContainerProps>`
  ${tw`relative z-10 flex w-full h-full max-w-full mx-auto transition-all duration-slow`}
  ${({ active }) => (active ? tw`opacity-100 visible` : tw`opacity-0 invisible`)}
  ${({ type }) => (type && type === "filter" ? tw`justify-start` : tw`justify-end`)}
  ${({ type }) => (type && type === "cart" ? tw`px-0` : "")}
`
// ${tw`relative z-10 flex justify-end w-full h-full max-w-xl mx-auto transition-all duration-slow`} // modal design

const ContainerInner = styled.div<ContainerInnerProps>`
  max-width: 476px;

  &::after {
    content: "";
    box-shadow: 0 0 0 1px #00000030;
    position: absolute;
    height: 100vh;
    top: 0;
    right: -30px;
    z-index: 99;
  }
  ${tw`w-full bg-light px-1-6 transition-all z-10 shadow-modal duration-slow`}
  ${({ active }) => (active ? tw`opacity-100 visible` : tw`opacity-0 invisible`)}
  ${({ type }) => (type && type === "cart" ? tw`px-0` : "")}
`
const ContentWrapper = styled.div<ContentWrapperProps>`
  ${tw`w-full transition-all z-30 md:max-w-49 xl:max-w-60 h-full min-h-full-vh`}
  ${({ right }) => (right ? tw`right-0` : null)}
  ${({ active }) => (active ? tw`duration-slow translate-y-0 opacity-100` : tw`translate-y-full opacity-0`)}
`
// ${tw`w-full transition-all z-30 md:max-w-49 h-full min-h-full-vh`}

const Content = tw.div`
  overflow-x-hidden overflow-y-auto h-full
`

const StyledIcon = tw(Icon)`
  block pt-1 pr-1
`
const Close = styled.button<CloseProps>`
  ${tw`absolute right-0 top-0 cursor-pointer hover:opacity-75 focus:outline-none z-10`}
  ${({ noClose }) => (noClose ? tw`hidden` : null)}
`
const CloseLayer = styled.div<CloseLayerProps>`
  ${tw`hidden md:block absolute w-full h-full cursor-pointer z-0`}
  ${({ background, type }) => (background && type !== "filter" ? tw`bg-dark opacity-20` : tw`opacity-0`)}
`

const ModalsDrawer = withModalsDrawer(({ active, setActive, children, right, noClose, type, activeCart, activeMenu }) => {
  return (
    <BgContainer background={`transparent`} active={active} activeCart={activeCart} activeMenu={activeMenu}>
      <CloseLayer onClick={() => setActive(false)} background type={type} />
      <Container width={`full`} active={active} type={type}>
        <CloseLayer onClick={() => setActive(false)} />

        <ContainerInner active={active} type={type}>
          <ContentWrapper active={active} right={right}>
            <Content>
              <Close noClose={noClose} onClick={() => setActive(false)} title={`close`}>
                <StyledIcon name={`close`} size={`small`} />
              </Close>
              {children}
            </Content>
          </ContentWrapper>
        </ContainerInner>
      </Container>
    </BgContainer>
  )
})

export default memo(ModalsDrawer)

type BgContainerProps = {
  active: boolean
}

type ContainerProps = {
  active: boolean
}

type ContainerInnerProps = {
  active: boolean
}

type ContentWrapperProps = {
  right: boolean
  active: boolean
}

type CloseProps = {
  noClose: boolean
}

type CloseLayerProps = {
  background?: boolean
}
